import React, { useState } from 'react';
import { m, useReducedMotion } from 'framer-motion';

export const MOTION_PRESETS = {
  public: { duration: 0.52, distance: 22 },
  app: { duration: 0.22, distance: 8 },
  dashboard: { duration: 0.42, distance: 14 },
};
const EASE = [0.22, 1, 0.36, 1];
const VISIBLE = { opacity: 1, y: 0 };
// Stable components: never create a new motion component during render.
const ELEMENTS = { div: m.div, section: m.section, article: m.article, h1: m.h1, h2: m.h2, p: m.p, span: m.span, a: m.a };

export default function Reveal({
  as = 'div', children, preset = 'public', delay = 0,
  trigger = 'scroll', keepVisible = false, onFocusCapture, ...props
}) {
  const reduceMotion = useReducedMotion();
  const [focused, setFocused] = useState(false);
  const config = MOTION_PRESETS[preset] || MOTION_PRESETS.public;
  const Component = ELEMENTS[as] || ELEMENTS.div;
  // Without observer support or an explicit motion preference, content stays visible.
  const instant = reduceMotion !== false || focused
    || (trigger === 'scroll' && typeof IntersectionObserver === 'undefined');
  const mount = trigger === 'mount' || instant;

  return (
    <Component
      {...props}
      data-flwrk-reveal=""
      initial={instant ? false : { opacity: keepVisible ? 1 : 0, y: config.distance }}
      animate={mount ? VISIBLE : undefined}
      whileInView={mount ? undefined : VISIBLE}
      viewport={{ once: true, amount: 0.12 }}
      transition={{ duration: instant ? 0 : config.duration, delay: instant ? 0 : Math.min(Math.max(delay, 0), 0.24), ease: EASE }}
      onFocusCapture={event => {
        // Tab navigation must never focus a visually hidden, delayed control.
        setFocused(true);
        onFocusCapture?.(event);
      }}
    >
      {children}
    </Component>
  );
}
